import { Controller } from "@hotwired/stimulus"
import { enter } from "el-transition";

export default class extends Controller {
    static targets = ["snackBarContainer", "snackBar", "loadingBar"]

    connect() {
        // An open modal dialog sits in the top layer above any z-index. Move into
        // it (Stimulus connects again there) and show as a popover above it.
        // Without the Popover API it stays in the page, behind the dialog.
        const dialog = document.querySelector("dialog[open]")
        if (dialog && !dialog.contains(this.element) && typeof this.element.showPopover === "function") {
            this.element.popover = "manual"
            dialog.addEventListener("close", () => this.leaveDialog(), { once: true })
            dialog.append(this.element)
            return
        }
        if (this.element.popover === "manual") this.element.showPopover()
        this.animateLoadingBar(5 * 1000)
        this.showSnackBar();
    }

    showSnackBar() {
        this.snackBarTarget.classList.remove("hidden");
        enter(this.snackBarTarget);
        const disappearAfterSeconds = this.snackBarContainerTarget.getAttribute('data-disappear-after-seconds');

        if (Boolean(disappearAfterSeconds)) {
            // Start the loading bar animation
            this.animateLoadingBar(disappearAfterSeconds, () => {
                this.hideSnackBar();
            });
        }
    }

    animateLoadingBar(duration, onComplete) {
        const loadingBar = this.loadingBarTarget;
        let startTime = null;
        const totalDuration = duration * 1000; // Convert duration to milliseconds

        function animate(currentTime) {
            if (!startTime) {
                startTime = currentTime;
            }

            const elapsedTime = currentTime - startTime;
            const progress = Math.min(elapsedTime / totalDuration, 1); // Ensure progress does not exceed 1

            const width = 100 * (1 - progress);
            loadingBar.style.width = `${width}%`;

            if (progress < 1) {
                requestAnimationFrame(animate);
            } else if (typeof onComplete === 'function') {
                onComplete();
            }
        }

        requestAnimationFrame(animate);
    }

    // A closing dialog may be removed, so the message returns to the page and
    // keeps its original timer.
    leaveDialog() {
        if (!this.element.parentNode) return
        if (this.element.matches(":popover-open")) this.element.hidePopover()
        this.element.removeAttribute("popover")
        document.body.append(this.element)
    }

    hideSnackBar() {
        this.element.remove();
    }
}
